import React, { FC } from 'react';
import * as classes from './TabsHeader.module.scss';
import cn from 'classnames';
import { TabInterface, TabsHeaderInterface } from '../../../../../../interfaces/tabs/TabHeader';
import Container from '../../../../../Common/Container/Container';
import Select from '../../../../../Common/Select/Select';
import { SelectOption } from '../../../../../../interfaces/SelectOption';
import Arrow from '../../../../../../assets/icons/inline/arrow-rigth-blue.inline.svg';
import { useTranslation } from 'gatsby-plugin-react-i18next';

interface Props extends TabsHeaderInterface {
  currentIndex?: number;
}

const TabsHeader: FC<Props> = ({ activeTabId, changeTab, items, navigation, currentIndex }) => {
  const { t } = useTranslation();
  const HeaderMapper = (item: TabInterface) => (
    <li key={item.id} onClick={() => changeTab(item.id)} className={cn(classes.item, activeTabId === item.id && classes.active)}>
      {item.label}
    </li>
  );

  const selectOnChange = (option: SelectOption) => {
    changeTab(option.value as string);
  };

  const currentTab = (): SelectOption | undefined => {
    const result = items.find(item => item.id === activeTabId);
    if (result) {
      return { value: result.id, label: result.label };
    }
    return undefined;
  };

  return (
    <section className={classes.wrapper} data-aos='fade-in'>
      <div className={classes.bgBlock} />
      <Container>
        <h1 className={classes.pageTitle}>{t('services.h1Title')}</h1>
        <div className={cn('row', classes.tabsWrapper)}>
          <div className={'col-lg-10'}>
            <ul className={classes.tabs} id={'tabsId'}>
              {items.map(HeaderMapper)}
            </ul>
          </div>
          <div className={'col-lg-2 m-auto'}>
            {navigation && (
              <div className={classes.nawWrapper}>
                <div onClick={navigation.prevTab}>
                  <Arrow />
                </div>
                <div className={classes.counter}>
                  {currentIndex}/{items.length}
                </div>
                <div onClick={navigation.nextTab} className={classes.arrowNext}>
                  <Arrow />
                </div>
              </div>
            )}
          </div>
        </div>
        <Select
          options={items.map(item => ({ label: item.label, value: item.id }))}
          onChangeAction={selectOnChange}
          wrapperClassName={classes.selectWrapper}
          listClassName={classes.selectList}
          value={currentTab()}
          inputClassName={classes.input}
          dropDownIconClassName={classes.dropDownIcon}
        />
      </Container>
    </section>
  );
};

export default TabsHeader;
